import { PackageOpen } from "lucide-react";

export const EmptyState = ({ icon: Icon = PackageOpen, title, text, action, testId = "empty-state" }) => (
  <div data-testid={testId} className="relative overflow-hidden rounded-2xl border border-dashed border-white/10 bg-white/[0.015] px-6 py-16 text-center">
    <div className="mx-auto grid h-14 w-14 place-items-center rounded-2xl border border-emerald-500/20 bg-emerald-500/10 text-emerald-300">
      <Icon size={24} />
    </div>
    <h3 className="mt-5 text-xl font-semibold text-white">{title}</h3>
    {text && <p className="mx-auto mt-2 max-w-md text-sm leading-relaxed text-slate-400">{text}</p>}
    {action && <div className="mt-6 flex justify-center">{action}</div>}
  </div>
);

const STATUS = {
  success: "border-emerald-500/30 bg-emerald-500/10 text-emerald-300",
  pending: "border-amber-500/30 bg-amber-500/10 text-amber-300",
  failed: "border-red-500/30 bg-red-500/10 text-red-300",
  cancelled: "border-slate-500/30 bg-slate-500/10 text-slate-300",
  active: "border-emerald-500/30 bg-emerald-500/10 text-emerald-300",
  disabled: "border-red-500/30 bg-red-500/10 text-red-300",
  soon: "border-violet-500/30 bg-violet-500/10 text-violet-300",
};

export const StatusBadge = ({ status, label, testId }) => (
  <span data-testid={testId} className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-semibold capitalize ${STATUS[status] || STATUS.cancelled}`}>
    <span className="h-1.5 w-1.5 rounded-full bg-current" />
    {label || status}
  </span>
);

export const PageHeader = ({ eyebrow, title, text, children }) => (
  <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
    <div className="rise">
      {eyebrow && <p className="eyebrow">{eyebrow}</p>}
      <h1 className="mt-2 text-3xl font-bold text-white sm:text-4xl">{title}</h1>
      {text && <p className="mt-2 max-w-2xl text-sm text-slate-400 sm:text-base">{text}</p>}
    </div>
    {children}
  </div>
);
